import { roomsCollection } from "@/firebase";
//import firebase from "firebase/app";
//import { v4 as uuidv4 } from "uuid";

const state = {
  rooms: [],
};

const getters = {};

const actions = {
  // eslint-disable-next-line
  addRoom({ commit }, payload) {
    return new Promise((resolve, reject) => {
      roomsCollection
        .where("client", "==", payload.client)
        // ker je lahko samo en array-contains, moramo drugi del naknadno preveriti spodaj
        .where("userId", "==", payload.userId)
        .where("recipientId", "==", payload.recipientId)
        .get()
        .then((querySnapshot) => {
          if (querySnapshot.empty) {
            roomsCollection
              .add(payload)
              .then(() => {
                resolve();
              })
              .catch((error) => {
                console.log(error);
                reject();
              });
          } else {
            querySnapshot.forEach((doc) => {
              let tMessages = doc.data().messages;
              tMessages.push(payload.messages[0]);
              if (tMessages.length > 5) tMessages.splice(0, 1);
              roomsCollection
                .doc(doc.id)
                .set(
                  {
                    lastModified: payload.lastModified,
                    messages: tMessages,
                    /*messages: firebase.firestore.FieldValue.arrayUnion(
                      ...payload.messages // tega ne uporabimo, ker moramo zgoraj omejiti št. sporočil na 5
                    )*/
                  },
                  { merge: true }
                )
                .then(() => {
                  resolve();
                })
                .catch((error) => {
                  console.log(error);
                  reject();
                });
            });
          }
        });
    });
  },
  // eslint-disable-next-line
  deleteRoom({ commit }, payload) {
    //console.log("RUN DELETE ROOM");
    return new Promise((resolve, reject) => {
      roomsCollection
        .doc(payload)
        .delete()
        .then(() => {
          resolve();
        })
        .catch((error) => {
          console.log(error);
          reject();
        });
    });
  },
  getRoom({ commit }, payload) {
    roomsCollection
      .where("client", "==", payload.client)
      .where("chatMembers", "array-contains", payload.uid)
      .onSnapshot((snapshot) => {
        let tempData = {};
        snapshot.docChanges().forEach(
          (change) => {
            tempData = Object.assign(change.doc.data(), {
              id: change.doc.id,
            });
            //console.log(tempData);
            if (change.type == "added") {
              //console.log("Room added.");
              commit("addRoom", tempData);
            } else if (change.type == "modified") {
              //console.log("Room modified.");
              commit("editRoom", tempData);
            } else if (change.type == "removed") {
              //console.log("Room deleted.");
              commit("deleteRoom", tempData);
            }
          },
          (error) => {
            console.log(error);
          }
        );
      });
  },
};

const mutations = {
  // ROOMS
  clearRooms(state) {
    state.rooms = [];
  },
  addRoom(state, payload) {
    state.rooms.push(payload);
    //console.log("COMMIT ADD Rooms.");
    //console.log(state.rooms);
  },
  editRoom(state, payload) {
    const index = state.rooms.findIndex((item) => item.id == payload.id);
    state.rooms.splice(index, 1, payload);
    //console.log("COMMIT EDIT Rooms.");
    //console.log(state.rooms);
  },
  deleteRoom(state, payload) {
    const index = state.rooms.findIndex((item) => item.id == payload.id);
    state.rooms.splice(index, 1);
    //console.log("COMMIT DELETE Rooms.");
    //console.log(state.rooms);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
